import {getCurrentYear} from '../../utils/commons'
import BestPetSuppliesPicksLogo from './logo'
import {bestPetSuppliesPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestpetsuppliespicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Pet Supplies Picks',
  favicon: '/favicons/bestpetsuppliespicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-QSFQX2BKGZ',
    camelCaseUrl: 'BestPetSuppliesPicks.com',
    logo: <BestPetSuppliesPicksLogo className="size-14 shrink-0 tablet:size-10" />,
    title: (_category: string, count: string) =>
      `Top ${count} Pet Supplies ${getCurrentYear()} in the US | BestPetSuppliesPicks.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Find the best pet products for ${getCurrentYear()} with expert reviews and comparisons. At BestPetSuppliesPicks.com, discover trusted recommendations to keep your pets happy, healthy, and well cared for.`,
    styles: bestPetSuppliesPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
